
webpack.register(
    'components/qualifying-local-table/qualifying-local-table',
    function() {
        return import('components/qualifying-local-table/qualifying-local-table');
    },
    true
);